module.exports = __webpack_public_path__ + "img/TC.4993f68e.png";